import { type RecurrenceSettingsState } from '../../../../types'
import { computeDefaultRecurrenceEndByRecurrenceType } from '../updateRecurrenceEnd/computeDefaultRecurrenceEndByRecurrenceType'

export function computeRecurrenceEnd(
  state: RecurrenceSettingsState,
  recurrenceType: uui.domain.ui.forms.ExtendedRecurrencePeriodType,
): uui.domain.client.rm.RecurrenceEnd {
  if (state.value.recurrenceEnd.endType === 'ON_DATE') {
    return {
      ...state.value.recurrenceEnd,
      endDate: computeDefaultRecurrenceEndByRecurrenceType(state, recurrenceType),
    }
  }

  return state.value.recurrenceEnd
}
